import { createFileRoute } from "@tanstack/react-router";
import { EditorPage } from "@/components/notices/editor/editor-page";

export const Route = createFileRoute("/_authenticated/notices/templates/$id/")({
  component: NoticeTemplateEditorRoute,
});

/** The template family's one authoring surface — full-bleed (see notices.tsx). */
function NoticeTemplateEditorRoute() {
  const { id } = Route.useParams();
  return <EditorPage templateId={id} />;
}
